import { axiosInstance as axios } from '@/plugins/axios';

const useAuthWithEmail = () => {
  const endpoint = `${process.env.NEXT_PUBLIC_RESERVE_ENDPOINT}/api/v1/auth/member/withEmail`;
  /**
   * Get generate password reset verification link
   * @param dataReq
   * @returns
   */
  const generateResetPasswordVerificationLink = async (dataReq?: any): Promise<{ isSuccess: boolean; data: any }> => {
    try {
      const data = await axios.post(`${endpoint}/generateResetPasswordVerificationLink`, { ...dataReq });
      return data.data;
    } catch (error) {
      throw error;
    }
  };

  return {
    generateResetPasswordVerificationLink,
  };
};

export default useAuthWithEmail;
